<div id="alerts" class="mx-n1">
  <div class="pt-2">
    <div *ngFor="let alert of appCommonUtils.alerts.slice(0, maxAlertCount)">
      <app-status-alert [type]="alert.level" (close)="appCommonUtils.closeAlerts(alert)" [msShowTime]="alert.msShowTime">{{alert.content}}</app-status-alert>
    </div>
    <div *ngIf="appCommonUtils.alerts.length > maxAlertCount">
      <div class="collapse" id="alertsColapse">
        <div *ngFor="let alert of appCommonUtils.alerts.slice(maxAlertCount)">
          <app-status-alert [type]="alert.level" (close)="appCommonUtils.closeAlerts(alert)" [msShowTime]="alert.msShowTime">{{alert.content}}</app-status-alert>
        </div>
      </div>
      <button class="btn btn-outline-danger float-right collapsed" type="button" data-toggle="collapse" data-target="#alertsColapse">
        <span class="more-alerts-button">Show more errors</span>
        <span class="fewer-alerts-button">Show fewer errors</span>
      </button>
    </div>
  </div>
</div>
